import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { Pagination, SearchTable, TableBody, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { CuttingList } from '../../TitleList';
import { selectEmpClothReturnDatalist } from '../../Selectors/Master/ItemSelectors';
import { fetchEmpClothCarryForwardList } from '../../../Store/PHPSlice/Cutting/cuttingApi';


const EmpWiseClothCarryForwardReg = () => {
    const dispatch = useDispatch();
    const cutdatalist = useSelector(selectEmpClothReturnDatalist);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchEmpClothCarryForwardList());
    }, [dispatch]);

    console.log("empclothlist=>",cutdatalist);
    const compData = Array.isArray(cutdatalist.data) ? cutdatalist.data.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            memoNo: item.ctMemo,
            empNm: item.empNm,
            clothNm: item.clothNm,
            baleNo: item.baleNo,
            cmtr: item.cmtr,
            sts: item.sts,
            barcd:item.barcd,
           
        }
    )) : [];


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

   const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
    (item.memoNo || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.empNm || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.clothNm || '').toLowerCase().includes(searchTerm.toLowerCase())
);

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    // const notFound = !dataFiltered.length;
    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>
            <Titlebar data={CuttingList} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Employee Wise Cloth Return Carray Forward Register </h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>


                            {/* <SearchTable handleRecordsPerPageChange={handleRecordsPerPageChange}
                                filterName={filterName}
                                handleFilterByName={handleFilterByName} /> */}

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'memoNo', label: 'Cutting Memo' },
                                                { id: 'empNm', label: 'Employee Name' },
                                                { id: 'clothNm', label: 'Cloth Name' },
                                                { id: 'baleNo', label: 'Bale No' },
                                                { id: 'barcode', label: 'Barcode' },
                                                { id: 'mtr', label: 'Carry Forward Mtr' },
                                                // { id: '', label: 'View' },
                                                { id: '', label: 'Forward Status' },
                                                // { id: '', label: 'Edit' },
                                              
                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {/* {dataFiltered
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row) => (
                                                <TableBody
                                                    key={row.srno}
                                                    id={row.srno}
                                                    dt={row.dt}
                                                    ordType={row.ordType}
                                                    empType={row.empType}
                                                    empTypeNm={row.empTypeNm}
                                                    masterNm={row.masterNm}
                                                    itemNm={row.itemNm}
                                                    memoNo={row.memoNo}
                                                    totQty={row.totQty}
                                                    instruction={row.instruction}
                                                    sts={row.sts}
                                                    cnt_cutId={row.cnt_cutId}
                                                    serialNumber={row.serialNumber}
                                                    cIssId={row.cIssId}
                                                    selected={selected.indexOf(row.name) !== -1}
                                                    handleClick={(event) => handleClick(event, row.name)}
                                                />
                                            ))} */}

                                        {displayedData.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                serialNumber={row.serialNumber}
                                                memoNo={row.memoNo}
                                                empNm={row.empNm}
                                                clothNm={row.clothNm}
                                                baleNo={row.baleNo}
                                                barcd={row.barcd}
                                                cmtr={row.cmtr}
                                                
                                                sts={row.sts}
                                               
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            {/* <Pagination
                                currentPage={currentPage}
                                npages={npages}
                                handlePrevPage={handlePrevPage}
                                handleNextpage={handleNextpage}
                                setCurrentPage={setCurrentPage}
                                renderPaginationButtons={renderPaginationButtons}
                                totalCount={totalCount}
                            /> */}

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default EmpWiseClothCarryForwardReg;
